module.exports = __webpack_public_path__ + "static/media/bird-template.bd11de5b.png";